import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";
import { NPC } from '../objects/NPC';
import { GameState } from "../objects/GameState";
import { PhaserModal, PhaserModalConfig } from "src/games/shared/Modal";
import initializeInteractiveCursor from "src/games/shared/InteractiveCursorUtil";
import { Color } from "src/games/shared/ColorValue";
import TranslateApi from "src/utils/TranslateHelper";
import { PhaserButtonConfig } from "src/games/shared/Button";
import { CharacterFeedbackScene } from "./CharacterFeedbackScene";
import { EndGameScene } from "src/games/FitFiveGame/scenes/EndGameScene";
import { numKeys } from "src/constants/KeyboardNumKeys";

export class PictureWallScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    astronaut: Phaser.GameObjects.Image;
    gameOver: boolean = false;
    private translateString = "FitFive.Phaser.MainScene.";

    constructor() {
        super({
            key: "PictureWallScene"
        });
    }

    preload(): void {
        this.load.tilemapTiledJSON('picture_wall', require("/src/assets/qci/maps/fitFiveGame/picture_wall.json"));
        this.load.image("correct", require("/src/assets/qci/sprites/correct_icon.png"));
        this.load.image("wrong", require("/src/assets/qci/sprites/delete_icon.png"));
    }

    create(): void {
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'picture_wall' });
        this.gameOver = false;
    }

    generateScene() {
        this.background = this.add.image(0, 0, "gym");
        this.background.setOrigin(0);
        this.addNPCs();
        this.bindNumKeys();
    }

    addNPCs(): void {
        var layer = this.map.getObjectLayer("NPC");
        var npcs = NPC.ALL_NPCS;
        layer.objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "astro") {
                this.astronaut = this.add.image(ob.x, ob.y, "pilots", "s");
                this.astronaut.setOrigin(0);
                this.astronaut.setDisplaySize(ob.width, ob.height);
            }
            else if (ob.name === "dialog") {
                var style = { fontSize: 15, fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", backgroundColor: "#000000", padding: 10 };
                var text = this.add.text(ob.x, ob.y, TranslateApi.translate(this.translateString + "quiz"), style);
                text.setDepth(1);
                text.setWordWrapWidth(ob.width, true);
                let border = this.add.image(text.x - 5, text.y - 5, "pixel");
                border.setOrigin(0);
                border.setDepth(.25);
                border.setDisplaySize(text.displayWidth + 10, text.displayHeight + 10);
                border.setTint(Color.PLANET_COLORS.get("S"));
            }
            else if (ob.type === "NPC") {
                var labelObject = this.map.getObjectLayer("labels").objects.find((l) => l.name === ob.name) as TiledGameObject;

                var npc = npcs.find((character: NPC) => character.assetKey === ob.name);
                var npcObject = this.add.image(ob.x, ob.y, "assets", npc.assetKey);
                npcObject.setOrigin(0);
                npcObject.setDisplaySize(ob.width, ob.height);
                npcObject.setInteractive();
                npc.object = npcObject;
                npcObject.on('pointerdown', () => {
                    this.clickedNPC(npc);
                });

                var name = TranslateApi.translate(npc.name);
                var job = TranslateApi.translate(npc.job);
                var labelText = (npc.id) + ': ' + name + TranslateApi.translate(this.translateString + "the") + job;
                var labelStyle = { fontSize: 14, fontFamily: 'Russo One, Arial', align: "center", backgroundColor: "#000000", padding: 10 };

                var npcLabel = this.add.text(labelObject.x, labelObject.y, labelText, labelStyle).setDepth(1);
                npcLabel.setWordWrapWidth(200, true);
                npc.label = npcLabel;

                let border = this.add.image(npcLabel.x - 2, npcLabel.y - 2, "pixel").setDisplaySize(npcLabel.displayWidth + 4, npcLabel.displayHeight + 4);
                border.setDepth(0.5).setOrigin(0).setTint(Color.PLANET_COLORS.get("S"));
                border.setInteractive();
                border.on('pointerdown', () => {
                    this.clickedNPC(npc);
                });

                ////// On the computer, show labels only on hovering (makes it look much less cluttered!)
                ////if (!this.sys.game.device.input.touch) {
                ////    npcLabel.setVisible(false);
                ////    border.setVisible(false);

                ////    npcObject.on('pointerover', () => {
                ////        npcLabel.setVisible(true);
                ////        border.setVisible(true);
                ////    });

                ////    npcObject.on('pointerout', () => {
                ////        npcLabel.setVisible(false);
                ////        border.setVisible(false);
                ////    });
                ////}
            }
        });
    }

    clickedNPC(npc: NPC) {
        if(this.gameOver) {
            // If the modal is on screen, it's because the game is over..don't let them keep messing around
            return;
        }
        GameState.current.currentNPC = npc;
        this.scene.setVisible(false, "PictureWallScene");
        this.scene.pause("PictureWallScene");
        this.scene.add("CharacterFeedbackScene", CharacterFeedbackScene, true);

        var loc = npc.object.getTopRight();
        var icon = this.add.image(loc.x + 5, loc.y - 5, "wrong");
        icon.setOrigin(0);
        icon.setDisplaySize(50, 50);
        icon.name = "icon";

        if (npc.id === 2 || npc.id === 5) {
            icon.setTexture('correct');
            icon.setDisplaySize(50, 50);
            npc.label.setTint(Color.COLORS.get("green"));
        }
        else {
            npc.label.setTint(Color.COLORS.get("light grey"));
        }
    }

    /**
     * Helper used when creating a modal
     */
    getModalConfig(title: string, buttonWidth: number, width: number, height: number): PhaserModalConfig {
        var config = new PhaserModalConfig();
        config.title = title;
        config.buttonWidth = buttonWidth;
        config.buttonConfig = new PhaserButtonConfig();
        config.buttonConfig.smartSize = true;

        return config;
    }

    /**
     * Checks if there is already a modal open on screen (we don't want to be able to add more than one modal to a scene)
     */
    isModalOnScreen(): boolean {
        var hasModal = this.children.list.find((c) => {
            return c.type === "PhaserModal";
        });
        if (hasModal) {
            return true;
        }
        else {
            return false;
        }
    }

    isGameOver(): boolean {
        var npc: NPC;
        for (npc of NPC.ALL_NPCS) {
            // Correct npc wasn't picked
            if (npc.id === 2 && !npc.picked) {
                return false;
            }
            if (npc.id === 5 && !npc.picked) {
                return false;
            }
        }
        return true;
    }

    update(): void {
        if (this.isGameOver() && !this.gameOver) {
            this.gameOver = true;
            // Pause one second before showing that the game is over
            setTimeout(() => {
                var text = TranslateApi.translate(this.translateString + "passedQuiz");
                var config = new PhaserModalConfig();
                config.title = text;
                config.buttonConfig.smartSize = true;
                var options = [{ id: 1, displayText: TranslateApi.translate("common.done") }];
                var modal = new PhaserModal(this, 0, 0, options, config);
                modal.setDepth(10);
                modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
                modal.on('optionClicked', () => {
                    modal.destroy();
                    this.input.removeAllListeners();
                    this.input.setDefaultCursor("default");
                    this.scene.setVisible(false, "PictureWallScene");
                    this.scene.add("EndGameScene", EndGameScene, true);
                    this.scene.remove(this);
                });
            }, 1000);
        }
    }

    onKeydown(event: Function, ...keys: string[]): void {
        keys.forEach((key: string) => {
            this.input.keyboard.on('keydown_' + key, event);
        });
    }

    bindNumKeys(): void {
        numKeys.forEach((key) => {
            this.onKeydown(() => {
                let npc = NPC.ALL_NPCS[key.index];
                this.clickedNPC(npc);
            }, key.keyCode, key.altKeyCode);
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/FitFiveGame/scenes/PictureWallScene.ts